import { createStore, createHook, createActionsHook } from 'react-sweet-state';

import type { ContentTimeframeLength } from '@atlassian/convo-ai-api';

export type FilterPeriod = 'since-last-visit' | ContentTimeframeLength;

const initialState = {
	selectedPeriod: 'since-last-visit' as FilterPeriod,
};

const actions = {
	changeToPeriod: (selectedPeriod: FilterPeriod) => {
		return ({ setState }: any) => {
			setState({ selectedPeriod });
		};
	},
	resetToDefault: () => {
		return ({ setState }: any) => {
			setState({ selectedPeriod: initialState.selectedPeriod });
		};
	},
};

export const PageCatchupDateFilterStore = createStore({
	initialState,
	actions,
});

export const usePageCatchupDateFilterStore = createHook(PageCatchupDateFilterStore);
export const usePageCatchupDateFilterStoreActions = createActionsHook(PageCatchupDateFilterStore);
